import { Button } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import type { ReportJobStatuses } from '@vy/types';
import { REPORT_JOB_STATUSES } from '@vy/types';
type DownloadReportButtonProps = {
  onClick: () => void;
  status: ReportJobStatuses;
};

export const DownloadReportButton: React.FC<DownloadReportButtonProps> = ({ onClick, status }) => {
  const isJobCompleted = status === REPORT_JOB_STATUSES.Completed;

  return isJobCompleted ? (
    <Button
      variant="outlined"
      size="small"
      color="primary"
      onClick={onClick}
      endIcon={<VyIcon icon="Download" style={{ transform: 'scale(0.8)' }} />}
    >
      Download
    </Button>
  ) : null;
};
